<template>
  <section>
    <alert-banner v-if="showBanner" :status="alertBannerStatus" class="w-full" :autoScrollToBanner="false">
      <span v-if="isPending">Job post under review</span>
      <span v-if="totalNewApplicants > 0">{{ newApplicantsTitle }}</span>
    </alert-banner>
    <div class="flex flex-row w-full gap-4 relative">
      <div class="text-primary w-full">
        <h3 class="job-text text-h5 mt-8" :class="{ '!text-grey-text-subdued': !isActiveOrPending }">
          {{ job.title }}
        </h3>
        <p
          class="job-text text-small text-grey-body"
          :class="{ 'text-grey-text-subdued': !isActiveOrPending }"
          data-testid="applicants-text"
        >
          {{ totalApplicantsText }}
        </p>
        <p v-if="!fcOwnsJob" class="job-text mb-8 text-body-2 text-grey-text-subdued">{{ jobDate }}</p>
        <p v-else-if="fcOwnsJob" class="job-text mb-8 text-body-2 text-grey-text-subdued">Posted by Family Concierge</p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import pluralize from 'pluralize';
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import JobPresenter from '@/lib/presenters/job_presenter';
import helperStatus from '@/helpers/status';

export default defineComponent({
  name: 'SeekerJobCardDescription',
  components: {
    AlertBanner,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
    accountID: {
      type: String,
      required: true,
    },
    showBanner: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      helperStatus,
    };
  },
  computed: {
    isPending(): boolean {
      return this.job.status === 'PENDING';
    },
    isActive(): boolean {
      return this.job.isActive;
    },
    isActiveOrPending(): boolean {
      return this.isActive || this.isPending;
    },
    totalNewApplicants(): number {
      return this.job.receivedApplications?.totalCount ?? 0;
    },
    newApplicantsTitle(): string {
      return `${this.totalNewApplicants} received ${pluralize('applicant', this.totalNewApplicants)}`;
    },
    totalApplicantsText(): string {
      const { totalCount } = this.job.applications;
      return `${totalCount} total ${pluralize('applicant', totalCount)}`;
    },
    jobDate(): string {
      return new JobPresenter(this.job).dateDescription();
    },
    fcOwnsJob(): boolean {
      return !(this.accountID === this.job.parent.id);
    },
    alertBannerStatus(): number {
      if (this.totalNewApplicants > 0) return helperStatus.Neutral;
      return helperStatus.Warn;
    },
  },
});
</script>

<style scoped lang="scss">
.job-text {
  @apply pt-0 pr-32 pb-4 pl-16;
}
</style>
